'use client'

import { useEffect, useRef } from 'react'

export default function TurnstileWidget({
  siteKey,
  onVerify,
  onError,
  onExpire,
  theme = 'auto',
  size = 'normal'
}) {
  const widgetRef = useRef(null)
  const widgetIdRef = useRef()

  useEffect(() => {
    const loadTurnstile = () => {
      if (window.turnstile && widgetRef.current) {
        widgetIdRef.current = window.turnstile.render(widgetRef.current, {
          sitekey: siteKey,
          callback: onVerify,
          'error-callback': onError,
          'expired-callback': onExpire,
          theme,
          size
        })
      }
    }

    // Load script if not already loaded
    if (!window.turnstile) {
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
      script.async = true
      script.defer = true
      script.onload = loadTurnstile
      document.head.appendChild(script)
    } else {
      loadTurnstile()
    }

    return () => {
      if (widgetIdRef.current && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current)
      }
    }
  }, [siteKey, onVerify, onError, onExpire, theme, size])

  return <div ref={widgetRef} />
}